// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__WdUpa","header":"PatientQuestionnaire_header__2ZiNi","info":"PatientQuestionnaire_info__tNYLW"};